<template>

    <div class="row product_values_block" :class="{'display-comments': displayComents}">
        <div class="col-md-2 first">
            <img src="/img/iconos/custom_default.svg" alt="custom_default.svg">

            <star-rating :read-only="true" :rating="rating" :show-rating="false" :star-size="20"></star-rating>

            <span class="num_values pointer" @click="showComents()">({{numValoracion}}) Ver valoraciones</span>
        </div>
        <div class="col-md-9">
            <h2 class="especie">{{variedad.especieName}}</h2>
            <h3 class="mote">{{variedad.moteName}}</h3>
            <h4 class="variedad">{{variedad.name}}</h4>
            <p class="descripcion" v-html="variedad.descripcion" v-if="variedad.descripcion"></p>
            <p class="descripcion" v-else>No hay ninguna descripcion asociada todavia.</p>
            <div class="see_values pointer" @click="showComents()">
                <i class="fa fa-angle-down" v-if="!displayComents"></i>
                <i class="fa fa-angle-up" v-else></i>
            </div>
        </div>
        <div class="col-md-1">
            <div class="value">
                <span>{{ratingBy10Formatted}}</span>
            </div>
        </div>
        <valoraciones-show v-if="displayComents" :rating="rating" :num-valoracion="numValoracion" :variedad-id="variedad.id"></valoraciones-show>
    </div>

</template>

<script>
    import StarRating from 'vue-star-rating';
    export default {
        components: {StarRating},
        name: "ProductBlockVarietyInfoModal",
        props: ['variedad','defaultOpen'],
        data() {
            return {
                displayComents: false,
            }
        },
        computed: {
            rating() {
                return this.variedad.rating;
            },
            numValoracion() {
                return this.variedad.num_valoraciones;
            },
            ratingBy10() {
                return this.rating * 2;
            },
            ratingBy10Formatted() {
                let rating = '-';
                if (this.ratingBy10 > 0) {
                    rating = this.ratingBy10.toFixed(1);
                }
                return rating;
            }
        },
        watch: {
            defaultOpen(val) {
                this.displayComents = val;
            }
        },
        methods: {
            showComents: function (event) {
                this.displayComents = !this.displayComents;
            }
        }
    }
</script>

<style scoped>

    .product_values_block {
        margin-bottom: 15px;
        background-color: white;
        padding-top: 13px;
    }

    .product_values_block.display-comments {
        border: solid 2px #028a83;
    }

    .product_values_block .first {
        text-align: center;
    }

    .product_values_block .especie {
        font-weight: bold;
        font-size: 20px;
        color: #0071bc;
        margin-bottom: 4px;
    }

    .product_values_block .mote {
        font-size: 15px;
        font-style: italic;
        margin-bottom: 4px;
        text-transform: uppercase;
    }

    .product_values_block .variedad {
        font-weight: bold;
        font-size: 15px;
    }

    .product_values_block img {
        width: 100%;
        max-width: 100px;
    }

    .see_values {
        text-align: center;
        color: #0071bc;
    }

    .num_values {
        color: #0071bc;
        font-weight: bold;
        font-size: 12px;
    }

    .product_values_block .value {
        border: 2px solid #0071bc;
        border-radius: 4px;
        color: #0071bc;
        background-color: #fec82f;
        width: fit-content;
        min-width: 30px;
        text-align: center;
    }

    .product_values_block .value span {
        font-size: 18px;
        font-weight: bold;
        padding: 3px;
    }

    .pointer {
        cursor: pointer;
    }

    .product_values_block p.descripcion {
        min-height: 72px;
    }

    .modal-body {
        padding: 0;
        background-color: #f9f9f9;
    }

    #modal-info-variedad .modal-body .vue-star-rating {
        margin-top: 0.5rem;
    }

</style>
